
import React, { SVGProps } from 'react';

const SvgAllAlerts = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
            <path d="M7.00035 14C6.21163 14 5.58696 13.3603 5.58696 12.5863H8.38009C8.38009 13.422 7.76874 14 6.99965 14H7.00035ZM11.2069 6.12513V9.69281L12.6203 11.1403V11.8468H1.38114V11.1403L2.79453 9.69281V6.12513C2.79453 3.90369 3.94501 2.08647 5.94942 1.58172V1.07698C5.94942 0.470999 6.40933 0 7.00105 0C7.59277 0 8.05268 0.470999 8.05268 1.07698V1.58172C10.0571 2.08647 11.2069 3.93743 11.2069 6.12513ZM12.5873 5.75465C12.4885 3.8362 11.5357 2.18698 10.1223 1.14375L11.108 0.134263C12.7843 1.44674 13.9011 3.46643 14 5.75465H12.5873ZM3.91136 1.14375C2.46502 2.18698 1.51224 3.8362 1.41339 5.75465H0C0.0988532 3.46572 1.21568 1.44674 2.89198 0.134263L3.91136 1.14375Z" fill="white" />
        </svg>
    );
}

export default SvgAllAlerts;